export const ServicesSection = {
    heading: 'Websites Improve Around Your Business Vision',
    description: 'Every business has a unique vision and we translate that into a digital experience. We don’t just build websites – we build online solutions that reflect your brand voice, goals and values. From layout and colour palettes to functionality and content structure, we align everything to your business objectives. It’s all about building digital platforms that amplify your business vision.',
    services: [
        {
            name: 'WordPress',
            logo: 'assets/img/logo/wordpress_logo.png',
            content: 'Sleek, professional websites with powerful content management. Flexible, user-friendly, SEO ready, and scalable for growth.',
        },
        {
            name: 'Joomla',
            logo: 'assets/img/logo/joomla_logo.png',
            content: 'Structured content control, great for memberships, e-commerce, and multilingual needs. Balanced performance and customisation.',
        },
        {
            name: 'Drupal',
            logo: 'assets/img/logo/drupal_logo.png',
            content: 'Enterprise-level security and customisation for portals, government, and education. Powerful performance and flexibility.',
        },
        {
            name: 'Custom PHP',
            logo: 'assets/img/logo/php_logo.png',
            content: 'Fully custom web solutions written cleanly from scratch. Perfect for businesses with specific functionality and database needs.',
        },
        {
            name: 'Page Speed Optimisation',
            logo: 'assets/img/logo/pagespeed_logo.png',
            content: 'Speed is key – for user experience and SEO. We use technical strategies like code minimisation, image compression, and smart caching to make sure your website loads fast, engages visitors, and ranks higher.',
        },
    ] 
};

export const CustomSection = {
  heading:
    "Transform Your Business with Professional Custom Web Development Services",
  description: `When off-the-shelf solutions won’t do, we build bespoke platforms tailored to your goals. Whether it's automation, user engagement, or launching new ideas, we develop systems that grow with you. More than code – it’s innovation for your business future.`,
  services: [
    {
      name: "PHP",
      link: "/php-web-development-agency",
      logo: "assets/img/logo/php_logo.png",
      content:
        "Secure, flexible and dynamic. Perfect for custom CMS or full applications – PHP gives us full control.",
    },
    {
      name: "Laravel",
      link: "/laravel-development-service",
      logo: "assets/img/logo/laravel_logo.png",
      content:
        "Our favorite PHP framework for high-performance modern apps. Clean code, secure, scalable – built to last.",
    },
    {
      name: "CakePHP",
      logo: "assets/img/logo/cakephp_logo.png",
      content:
        "Rapid, structured development with less code. Great for scalable, maintainable platforms with strong MVC.",
    },
    {
      name: "Node.js",
      link: "/node-js-development-service",
      logo: "assets/img/logo/node_logo.png",
      content:
        "Fast, real-time web apps with server-side power. Perfect for live features like chat, APIs and streaming.",
    },
    {
      name: "MEAN Stack",
      link: '/full-stack-development-service',
      logo: "assets/img/logo/mean_logo.png",
      content:
        "Full stack JavaScript from Mongo to Angular. We build fast, scalable applications across all devices.",
    },
    {
      name: "CodeIgniter",
      logo: "assets/img/logo/codeignitor_logo.png",
      content:
        "Lightweight and high performance PHP framework. Perfect for quick development cycles and efficient delivery.",
    },
  ],
};


export const BenefitSection = {
  heading: "Benefits of Our Custom Website Development Services",
  description:
    "Great websites don’t just look good – they perform, scale, and deliver results. Our approach focuses on purpose-driven development with long-term scalability, high security, and a flawless user experience.",
  services: [
    {
      name: "Tailored eCommerce Solutions",
      // logo: "https://cdn-icons-png.flaticon.com/512/1170/1170576.png",
      content:
        "Seamless shopping experiences with conversion-focused design and secure payment integration—built for your business model.",
    },
    {
      name: "High Security",
      // logo: "https://cdn-icons-png.flaticon.com/512/942/942748.png",
      content:
        "From encrypted connections to secure code and firewalls, we protect your platform and customer trust 24/7.",
    },
    {
      name: "Easy to Understand",
      // logo: "https://cdn-icons-png.flaticon.com/512/1828/1828961.png",
      content:
        "Powerful admin panels, intuitive navigation, and full training ensure you're in control of your site, no devs required.",
    },
    {
      name: "Better Competitive Advantage",
      // logo: "https://cdn-icons-png.flaticon.com/512/889/889118.png",
      content:
        "Custom websites deliver SEO, speed, and brand clarity your competitors can't match—position your business to lead.",
    },
    {
      name: "Optimized for Performance",
      // logo: "https://cdn-icons-png.flaticon.com/512/753/753318.png",
      content:
        "Fast load times, cross-browser consistency, and mobile readiness baked into every line of code we deliver.",
    },
    {
      name: "Fast and Flexible",
      // logo: "https://cdn-icons-png.flaticon.com/512/1256/1256650.png",
      content:
        "Need to evolve? We build modular and scalable systems designed to grow and adapt alongside your business.",
    },
  ],
};

export const BoostSection = {
  heading: "Boost Your Business with Customised Solutions from Warrgyizmorsch",
  description: `At Warrgyizmorsch, we work collaboratively. Every solution we build is custom-designed for your business needs and goals. We don’t just write code—we strategize, innovate, and build platforms that deliver results. Whether you need a complex web app, e-commerce site, or landing page, we bring your vision to life. With hands-on support and tailored strategies, we help you scale with confidence. You’re not just another project—you’re a partner. Let us show you what custom digital looks like.`,
  button: "Let’s Build Together",
};


export const AssistanceSection = {
  heading: "Need Assistance with Web Application Development Company",
  content: `We’ll help you navigate the digital landscape with ease. Whether you’re a start-up looking for your first app or an established business looking to scale, our team has the expertise you need more than other web development services. We specialise in custom web apps that solve real problems and add real value. Let’s build something amazing together.`,
  subHeading: "Need a Custom Website Developer?",
  subContent: `Looking for a custom website developer who gets your goals and vision? You’re in the right place. We, as a web development agency, offer fully tailored web development services—from design to deployment. With Warrgyizmorsch you get more than code—you get a partner who’s committed to your success. Let’s turn your ideas into a powerful online presence.`,
  image: "assets/img/icon/webassist.png",
};


export const FAQ = [
  {
    header: "Web Development",
    question: "What Does a Website Design & Development Consultant Do?",
    answer:
      "We help businesses plan, design and build websites that meet specific goals. We’re your digital advisor – we analyse your business, your target audience and recommend the best solutions. Like all other well-established website design companies, we also focus on usability, performance, SEO and brand alignment so your website works.",
  },
  {
    header: "Web Development",
    question:
      "How Long Does a Web Development Project Take to Complete from Start to Finish?",
    answer:
      "A custom web development project can take anywhere from 4 to 12 weeks depending on complexity. Small sites can launch in a month, bigger platforms can take longer. We provide clear timelines and updates throughout the process. We deliver high quality results, on time.",
  },
  {
    header: "Web Development",
    question: "Do You Ensure My Website Is Search Engine Friendly?",
    answer:
      "Yes. We build every website with SEO in mind. From clean URLs and responsive design to meta-tagging and fast load times, everything is optimised for visibility. We also implement schema mark-up and SEO friendly code so search engines can better understand your site. Your online visibility is top priority for us.",
  },
  {
    header: "Web Development",
    question:
      "What Are the 5 Benefits of Custom Website Design and Development?",
    answer:
      "Custom web design means a tailored experience, stronger branding, better performance, more scalability and competitive advantage. We make sure your website matches your vision and works across all devices. A custom solution means better SEO, security and flexibility – a long term asset for your business.",
  },
  {
    header: "Web Development",
    question: "Why Is Website Development Important for a Business?",
    answer:
      "Website development is important because it’s your digital shop front. It helps establish credibility, customer engagement and conversions. A well-developed site reflects your brand’s professionalism and values. It supports marketing strategies, streamlines operations and can impact your business growth. We help you build that foundation.",
  },
  {
    header: "Web Development",
    question:
      "How Can You Make Sure the Website Aligns with My Brand Identity and Business Goals?",
    answer:
      "We start by understanding your brand values, voice and business goals. Then we translate that into design, layout and functionality that matches your identity. From colours and typography to content strategy and features, everything is aligned to your brand. Regular feedback loops mean the final product supports your vision 100%.",
  },
  {
    header: "Web Development",
    question: "How Long Does it Take to Develop a Custom Website?",
    answer:
      "The time to develop a custom website depends on the project complexity. On average our projects take 6 to 10 weeks. We provide a roadmap at the start with milestones for design, development, testing and launch. Our process is transparent and efficient so you don’t get held up. Your time is important to us.",
  },
];
